import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2,
} from '@angular/core';
import { PricingFilterValues } from '@app/pages/gallery/pricing-filter/pricing-filter-values';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';

@Directive({
  selector: '[appCategory]',
})
export class CategoryDirective implements OnInit {
  @Input({ required: true })
  appCategory!: string;

  @Input()
  appCategoryPrice?: PricingFilterValues;

  constructor(
    private elementRef: ElementRef,
    private store: Store,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    // Construct the URL with the query parameter
    let href = `/gallery?category=${encodeURIComponent(this.appCategory)}`;
    if (this.appCategoryPrice) {
      href += `&is_free=${encodeURIComponent(this.appCategoryPrice)}`;
    }
    // Set the href attribute on the element
    this.renderer.setAttribute(this.elementRef.nativeElement, 'href', href);
  }

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.preventDefault(); // Prevent default navigation if necessary
    this.store.dispatch(
      new Navigate(['/gallery'], {
        category: this.appCategory.toString(),
        is_free: this.appCategoryPrice,
      }),
    );
  }
}
